{
  "page": {
    "title": "التقارير",
    "subtitle": "الأرقام مبنية على الحجوزات المدفوعة خلال الفترة",
    "exportExcel": "تصدير Excel"
  },
  "filters": {
    "period": "الفترة",
    "thisMonth": "هذا الشهر",
    "sixMonths": "آخر 6 أشهر",
    "thisYear": "هذه السنة",
    "custom": "فترة مخصصة",
    "from": "من",
    "to": "إلى"
  },
  "stats": {
    "paidBookings": "الحجوزات المدفوعة",
    "fees": "إجمالي الرسوم",
    "shares": "حصص المنسقين",
    "net": "صافي المنشأة",
    "expenses": "المصروفات",
    "profit": "صافي الربح",
    "profitSub": "صافي المنشأة − المصروفات"
  },
  "chart": {
    "title": "الرسوم الشهرية: الصافي وحصص المنسقين",
    "fees": "الرسوم: {{value}}",
    "shares": "حصص المنسقين: {{value}}",
    "net": "الصافي: {{value}}",
    "expenses": "المصروفات: {{value}}",
    "profit": "صافي الربح: {{value}}",
    "bookings": "{{n}} حجوزات",
    "legendNet": "الصافي",
    "legendShares": "حصص المنسقين"
  },
  "tables": {
    "byPartner": "حسب الشريك",
    "partner": "الشريك",
    "bookings": "الحجوزات",
    "totalFees": "إجمالي الرسوم",
    "byCoordinator": "حسب المنسق",
    "coordinator": "المنسق",
    "totalShares": "إجمالي الحصص",
    "empty": "لا توجد بيانات في هذه الفترة."
  }
}
